import React, { useEffect } from 'react'
import { browserHistory } from 'react-router'
import { Layout } from '@surecompanies/core_components'
import Page from 'layouts/Page'
import PageWrapper from 'enrollment-platform/PageWrapper'
import BreadcrumbNav from 'enrollment-platform/components/Breadcrumbs'
import useFeatureFlags from 'hooks/useFeatureFlags'
import { UsersTable } from '../../components/UserManagement/UsersTable'
import RequirePermission from 'enrollment-platform/rbac/RequirePermission'
import { NoAdminAccess } from 'enrollment-platform/rbac/NoAdminAccess'
import { RbacActions, RbacSubjects } from 'enrollment-platform/rbac/constants'
import { BillingProfileTabsHeader } from '../../components/BillingProfileTabsHeader'
import { BILLING_PROFILE_TAB_KEYS } from '../../constants'

const { Content } = Layout

export default function UserManagement() {
  const { flags } = useFeatureFlags()
  const isEnabled = flags['admin.finance.user-invitations-enabled']

  useEffect(() => {
    if (!isEnabled) {
      browserHistory.replace('/not-found')
    }
  }, [isEnabled])

  if (!isEnabled) {
    return null
  }

  return (
    <PageWrapper>
      <Page
        title="Billing Profile"
        maxWidth="100%"
        breadcrumb={
          <BreadcrumbNav
            items={[
              { title: 'Finance', path: '/finance' },
              { title: 'Billing Profile' },
            ]}
          />
        }
      >
        <BillingProfileTabsHeader
          activeTab={BILLING_PROFILE_TAB_KEYS.FUNDING_MANAGERS}
        />

        <Layout style={{ backgroundColor: '#F7F9FC' }}>
          <Content
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              padding: '24px',
            }}
          >
            <RequirePermission
              action={RbacActions.Manage}
              subject={RbacSubjects.OnboardingUser}
              fallback={<NoAdminAccess />}
            >
              <UsersTable />
            </RequirePermission>
          </Content>
        </Layout>
      </Page>
    </PageWrapper>
  )
}
